import { useState } from 'react';

export const useModalState = (props) => {
  const [open, setOpen] = useState(props?.defaultValue || false);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  return {
    open,
    openModal,
    closeModal,
  };
};
